<button
  type="button"
  class="pill-button"
  [disabled]="disabled"
  [class.pill-button--has-icon]="hasLeftIcon"
  [class.pill-button--visually-disabled]="visuallyDisabled"
  [class.pill-button--has-forward]="showForwardIcon"
  [class.pill-button--size-xl]="size === 'xl'"
  [class.pill-button--size-medium]="size === 'medium'"
  [class.pill-button--size-medsmall]="size === 'medsmall'"
  [class.pill-button--size-small]="size === 'small'"
  [class.pill-button--size-compact]="size === 'compact'"
  [class.pill-button--size-xs]="size === 'xs'"
  [class.pill-button--size-micro]="size === 'micro'"
  [style.background]="background"
  [style.--pill-text-color]="textColor"
  [style.--pill-forward-color]="forwardIconColor"
  [style.--pill-forward-hover-color]="forwardIconHoverColor"
  [style.--pill-forward-arrow-color]="forwardArrowColorValue"
  [style.--pill-forward-arrow-hover-color]="forwardArrowHoverColor"
  (click)="clicked.emit()"
>
  <span class="pill-button__content">
    <span class="pill-button__icon" *ngIf="hasLeftIcon">
      <ng-content select="[pillIcon]"></ng-content>
    </span>

    <span
      class="pill-button__text"
      [class.pill-button__text--two-line]="!!subtitle"
    >
      <span class="pill-button__title">{{ title }}</span>
      <span class="pill-button__subtitle" *ngIf="subtitle">{{ subtitle }}</span>
    </span>
  </span>

  <span class="pill-button__forward" *ngIf="showForwardIcon" aria-hidden="true">
    <img [src]="forwardIconSrc" alt="">
  </span>
</button>
